import HomeHero from './HomeHero';

export default HomeHero;

// Exports adicionales por si se necesitan en otros lugares
export { default as HeroSlide } from './HeroSlide';
export { default as HeroNavigation } from './HeroNavigation';
export { default as HeroIndicators } from './HeroIndicators';
export { default as Countdown } from './shared/Countdown';
export { default as ActionButton } from './shared/ActionButton';

// Hooks
export { default as useCarousel } from './hooks/useCarousel';
export { default as useCountdown } from './hooks/useCountdown';
export { default as useResponsive } from './hooks/useResponsive';

// Banner registry
export { BANNER_REGISTRY, isBannerTypeValid, getBannerComponent } from './banners';
